import * as customAssetsReducers from './custom-assets.reducers';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export interface CustomAssetReducerState {
  customAssets: customAssetsReducers.CustomAssetsState;
}

export const reducers: ActionReducerMap<CustomAssetReducerState> = {
  customAssets: customAssetsReducers.reducer,
};

export const getCustomAssetsState = createFeatureSelector<CustomAssetReducerState>('customAssets');
